<template>
	<div id="content-map">
		<rutify-here-map
			name="theMap"
			:lat="latitude ? latitude : '4.671469'"
			:lng="longitude ? longitude : '-74.073240'"
			:zoom="zoom ? zoom : '12'"
			:width="width ? width : widthMap"
			:height="height ? height : '100vh'"
			:theme="mapTheme"
			:class="[calledFrom === 'maps' ? 'themap map-custom-container' : 'themap map-custom-container-calendar']"
			:module="calledFrom"
		></rutify-here-map>
		<!-- <side-bar></side-bar> -->
		<map-view-sidebar
			v-if="calledFrom === 'maps'"
			ref="mapviewsidebar"
			:isSidebarActive="isSidebarActive"
			@closeSidebar="toggleDataSidebar"
			:handleChangeGroupTrigger="handleChangeGroup"
		/>

		<vs-button
			v-if="calledFrom === 'maps'"
			@click.stop="toggleDataSidebar(true)"
			type="filled"
			size="large"
			class="customizer-btn-map-opc"
			icon-pack="feather"
			icon="icon-menu"
		/>
		<vs-button
			v-if="calledFrom === 'maps'"
			@click.stop="clearMap"
			size="large"
			class="customizer-btn-map-clear"
			icon-pack="feather"
			icon="icon-trash-2"
		/>
		<map-settings v-if="calledFrom === 'maps'"></map-settings>
		<georreferencer v-if="isGeoActive" class="map-top-right-possition" />
		<routes-legends
			v-show="isRoutesLegendsActive && calledFrom === 'maps'"
			:class="$store.state.reduceButton ? 'map-top-left-possition-reducce-button' : 'map-top-left-possition'"
			:getAssigedZoneResource="getAssigedZoneResource"
			:clearPolygons="clearPolygons"
		/>
	</div>
</template>

<script>
import {
	infoWindowContentResourceTracking,
	infowindowContentResource,
	infowindowContentResourceOnDemand,
} from "./infowindowContent";

const {cartoTable} = cartodb;
import mapMethods from "./mapMethods";
import MapViewSidebar from "./MapViewSidebar";
import moduleCommon from "@/store/common/moduleCommon.js";
import moduleZonification from "@/store/zonification/moduleZonification.js";
import moduleVisitPoint from "@/store/visit-point/moduleVisitPoint.js";
import carto from "@carto/carto.js";
import cartoDB from "@/helpers/cartoDB";
import cartodb from "@/constants/cartodb.js";
//Models
import VisitPoint from "@/models/VisitPoint.js";
import Zone from "@/models/zone.js";
import visitPointImg from "@/assets/images/markers/visit_point.png";
// Working with Infowindows
import InfowindowVisitPoint from "@/components/Maps/InfowindowVisitPoint.vue";
import Vue from "vue";
import Georreferencer from "./Georreferencer.vue";
import RoutesLegends from "./RoutesLegends.vue";
import RutifyHereMap from "./HereMap";
import MapSettings from "./MapSettings";
import {
	addCircleToMap,
	addClickEvent,
	addInfoBubble,
	addMarkerHereMap,
	centerHereMap,
	changeIconInMarkerHereMap,
	clearMap,
	fitBoundsMarkerGroup,
	getCurrentPosition,
	getHereMapObj,
	removeGeoJsonLayer,
	removeRoute,
	setMapViewBounds,
	showGeoJSONData,
	zoomMap,
} from "../../utils/HereMap";
import firebase from "firebase/app";
import Infowindow from "./Infowindow";
import Tracking from "@/models/Tracking.js";
import moduleGroup from "@/store/group/moduleGroup.js";
import Group from "@/models/Group.js";
import Notification from "@/models/Notification.js";

let ComponentClass = Vue.extend(InfowindowVisitPoint);
let ComponentClassResourceActive = Vue.extend(Infowindow);

export default {
	name: "HereMap",
	components: {
		MapSettings,
		RutifyHereMap,
		MapViewSidebar,
		InfowindowVisitPoint,
		Georreferencer,
		RoutesLegends,
	},
	props: {
		name: {
			type: String,
			required: true,
			default: "themap",
		},
		latitude: {
			type: String,
			required: false,
			default: "51.51455",
		},
		longitude: {
			type: String,
			required: false,
			default: "-0.07306",
		},
		zoom: {
			type: String,
			required: false,
			default: "12",
		},
		theme: {
			type: String,
			required: false,
			default: null,
		},
		width: {
			type: String,
			required: false,
			default: null,
		},
		height: {
			type: String,
			required: false,
			default: null,
		},
		calledFrom: {
			type: String,
			required: false,
			default: "maps",
		},
		cartodbId: {
			type: Number,
			default: 0,
		},
		markerData: {
			type: Object,
			default: () => {},
		},
		addResourceMarkerTrigger: 0,
		showResourceMarkerTrigger: 0,
		hiddeResourceMarkerTrigger: 0,
		openInfowindowMarkerTrigger: 0,
		changeCursorEnable: {
			type: Boolean,
			default: false,
		},
		getCallbackClick: {
			type: Function,
			default: () => {},
		},
		resourceViewAssignedZones: {
			type: Array,
			default: () => [],
		},
		resourceViewActiveTab: {
			type: Number,
			default: 0,
		},
	},
	data() {
		return {
			numDeltas: 100,
			delay: 10,
			currentPosition: {},
			i: 0,
			deltaLat: null,
			deltaLng: null,
			tracking: new Tracking({}),
			listResourceMarkers: [],
			listResources: [],
			database: firebase.database(),
			active: false,
			map_theme_local: this.theme,
			client: cartoDB.client(),
			instanceInfo: null,
			visitPoint: new VisitPoint({}),
			selectedZone: new Zone({}),
			cartoLayerIds: [],
			resourceMarkers: [],
			positionArray: [],
			PANIC_ALARM: "PANIC_ALARM",
			// variables creadas para integrar con modulo OnDemandHistory.vue
			onDemandResourceTracking: null,
			resourceRefs: [],
			favoriteGroup: new Group({}),
			changeGroupTrigger: 0,
			circle: null,
		};
	},
	created() {
		if (!moduleCommon.isRegistered) {
			this.$store.registerModule("moduleCommon", moduleCommon);
			moduleCommon.isRegistered = true;
		}
		if (!moduleZonification.isRegistered) {
			this.$store.registerModule("moduleZonification", moduleZonification);
			moduleZonification.isRegistered = true;
		}
		if (!moduleVisitPoint.isRegistered) {
			this.$store.registerModule("moduleVisitPoint", moduleVisitPoint);
			moduleVisitPoint.isRegistered = true;
		}
		if (!moduleGroup.isRegistered) {
			this.$store.registerModule("moduleGroup", moduleGroup);
			moduleGroup.isRegistered = true;
		}
	},
	mounted() {
		const currentModuleName = this.$store.state.currentModule.name;
		const zoom = document.querySelector(".H_l_bottom");
		if (zoom != null) {
			zoom.setAttribute("style", "left: 60px");
		}
		getCurrentPosition();
		if (this.calledFrom === "alarmForm" && this.cartodbId > 0) {
			this.drawCartoPolygons(this.cartodbId);
		}
		if (this.changeCursorEnable) {
			addClickEvent(this.callbackClickOnMap);
			this.changeCursor("crosshair");
		}
		// Esto se ejecuta cuando se hace click en el mapa desde el historial de ondemand
		if (currentModuleName === "apps-on-demand-history" && this.markerData.length > 0) {
			this.handleMountedFromOnDemand();
		}
		if (this.$store.state.currentModule.name === "app-resource-view") {
			this.handleMountedFromResourceView();
		}
		if (this.defaultGroupTracking.id && currentModuleName === "dashboard-maps") {
			this.startDefaultGroupTracking(this.defaultGroupTracking);
		}
		if (this.calledFrom === "maps") this.$store.commit("moduleMap/SET_MODULE_TYPE", this.calledFrom);
		if (this.$route.params.notification) {
			const notification = new Notification(this.$route.params.notification);
			setTimeout(() => {
				this.locatePanicAlarm(notification);
			}, 500);
		}
	},
	beforeDestroy() {
		this.$store.commit("moduleMap/SET_MODULE_TYPE", null);
		this.$store.dispatch("moduleMap/closePopupRouteLegends", false);
		this.$store.commit("moduleMap/CLEAR_ZONE_GEOCERCA");
		if (this.listResourceMarkers.length > 0) {
			this.listResourceMarkers.forEach((marker) => {
				marker.setData(null);
			});
			this.listResourceMarkers = [];
		}
		this.$store.commit("MAP_MODULE_MOUNTED", false);
		this.clearMap();
	},
	watch: {
		onDemandResourceTracking(val) {
			const foundResource = this.resourceMarkers.find(({info}) => +info.resource_id === +val.resource_id);
			if (foundResource) {
				this.changeMarkerPosition({lat: +val.cy, lng: +val.cx});
			}
		},
		addResourceMarkerTrigger() {
			this.markerData.forEach((resource) => {
				this.addMarkerResource(resource);
			});
		},
		hiddeResourceMarkerTrigger() {
			this.resourceMarkers.forEach((marker) => {
				marker.setData(null);
			});
			this.resourceMarkers = [];
		},
		getSelectedGroup(val) {
			this.clearMap();
			this.startDefaultGroupTracking(val);
		},
		"locatePanicAlarmTrigger.trigger"(val) {
			const notification = new Notification(this.locatePanicAlarmTrigger.notification);
			this.locatePanicAlarm(notification);
		},
	},
	computed: {
		windowWidth() {
			return this.$store.state.windowWidth;
		},
		//Implements Here Map
		mapTheme() {
			return this.$store.state.moduleMap.mapStyle;
		},
		isSidebarActive() {
			return this.$store.state.moduleMap.toggleMapSidebar;
		},
		isGeoActive() {
			return this.$store.state.moduleMap.toggleGeorreferencer;
		},
		isRoutesLegendsActive() {
			return this.$store.state.moduleMap.toggleRoutesLegends;
		},
		widthMap() {
			let widthValue = "";
			if (this.$store.state.reduceButton && this.windowWidth > 1200) {
				widthValue = "94vw";
			} else if (this.windowWidth > 1200) {
				widthValue = "80vw";
			} else {
				widthValue = "100vw";
			}
			return widthValue;
		},
		assignedVisitPoints() {
			return this.$store.state.moduleVisitPoint.assignedVisitPoints;
		},
		locatePanicAlarmTrigger() {
			return this.$store.state.moduleMap.locatePanicAlarm;
		},
		resources() {
			return this.$store.getters["chat/contacts"];
		},
		getSelectedGroup() {
			return this.$store.getters["moduleGroup/getSelectedGroup"];
		},
		defaultGroupTracking() {
			return this.$store.state.modulePreferences.default_group_tracking;
		},
	},
	methods: {
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		toggleDataSidebar(val = false) {
			this.$store.dispatch("moduleMap/changeToggleMapSidebar", val);
		},
		clearMap() {
			clearMap();
			removeRoute();
			removeGeoJsonLayer();
			this.$store.commit("moduleMap/TOGGLE_ROUTES_LEGENDS", false);
			this.$store.commit("moduleMap/CLEAR_MAP_COLOR");
			this.$store.commit("moduleMap/CLEAR_ZONE_GEOCERCA");
		},
		clearPolygons() {
			removeGeoJsonLayer();
			zoomMap(8);
		},
		drawCartoPolygons(cartodbIds, options = {cleanPolygon: true}) {
			cartoDB
				.executeQueryWithBounds(`SELECT * FROM ${cartoTable} WHERE cartodb_id IN (${cartodbIds})`)
				.then((res) => {
					if (options.cleanPolygon) {
						removeGeoJsonLayer();
						showGeoJSONData(res["data"]);
						this.fitBoundGeoJson(cartodbIds);
					} else {
						showGeoJSONData(res["data"]);
					}
				})
				.catch((err) => {
					throw new Error(err);
				});
		},
		fitBoundGeoJson(cartodbIds) {
			cartoDB
				.executeQueryWithBounds(
					`WITH bbox as (SELECT ST_Envelope(the_geom) as the_geom FROM ${cartoTable} WHERE cartodb_id IN (${cartodbIds}))
                                    SELECT the_geom, ST_Xmax(the_geom) as xmax,
                                    ST_Ymax(the_geom) as ymax,
                                    ST_Xmin(the_geom) as  xmin,
                                    ST_Ymin(the_geom) as ymin
                                    FROM bbox`
				)
				.then((res) => {
					let geoJson = null;
					if (res.data.features.length > 1) {
						let aux = [];
						res.data["features"].forEach((elem, index) => {
							aux[index] = elem.properties;
						});
						let xmin = aux[0].xmin;
						let xmax = aux[0].xmax;
						let ymin = aux[0].ymin;
						let ymax = aux[0].ymax;
						aux.forEach((item, index) => {
							if (xmin > aux[index].xmin) {
								xmin = aux[index].xmin;
							}
							if (xmax < aux[index].xmax) {
								xmax = aux[index].xmax;
							}
							if (ymin > aux[index].ymin) {
								ymin = aux[index].ymin;
							}
							if (ymax < aux[index].ymax) {
								ymax = aux[index].ymax;
							}
						});
						geoJson = {properties: {xmin: xmin, xmax: xmax, ymin: ymin, ymax: ymax}};
					} else {
						geoJson = res.data["features"][res.data["features"].length - 1];
					}
					setMapViewBounds(geoJson);
				});
		},
		zoomBoundsGroup(cartodbIds) {
			cartoDB
				.executeQueryWithBounds(
					`WITH bbox as (SELECT ST_Envelope(the_geom) as the_geom FROM ${cartoTable} WHERE cartodb_id IN (${cartodbIds}))
                SELECT the_geom, ST_Xmax(the_geom) as xmax,
                ST_Ymax(the_geom) as ymax,
                ST_Xmin(the_geom) as  xmin,
                ST_Ymin(the_geom) as ymin
                FROM bbox`
				)
				.then((res) => {
					//obtener todas las coordenadas max y min de las salida de la consulta y hacer zonn sobre ellas
					var min = res.data["features"].map((f) => ({
						lat: f.properties.ymin,
						lng: f.properties.xmin,
					}));
					var max = res.data["features"].map((f) => ({
						lat: f.properties.ymax,
						lng: f.properties.xmax,
					}));
					fitBoundsMarkerGroup(min.concat(max));
				})
				.catch((err) => {
					throw new Error(err);
				});
		},
		removeLayers() {
			removeGeoJsonLayer();
		},
		addMarkerVisitPoint(visitPoint, draggable = true, title = this.$t("MapModule.CurrentPosition")) {
			this.visitPoint = visitPoint;
			const lat = visitPoint.cy,
				lng = visitPoint.cx;
			// Opciones
			let options = {
				drag: draggable,
				icon: visitPointImg,
				title,
				label: {
					text: "A",
					color: "#fff",
					fontSize: "11.0px",
				},
				infoWindow: {
					content: this.mountInfowindowComponent(),
				},
				onDragend: (e, coords) => {
					this.visitPoint.cy = parseFloat(coords.lat).toFixed(8);
					this.visitPoint.cx = parseFloat(coords.lng).toFixed(8);
					this.$emit("geoInversoEmit", {
						country: this.visitPoint.country,
						cy: coords.lat,
						cx: coords.lng,
					});
				},
			};
			let newMarkers = addMarkerHereMap(lat, lng, options, true);
			addInfoBubble(newMarkers, options.infoWindow.content);
			centerHereMap(lat, lng, {zoom: 18});
			this.positionArray.push(newMarkers);
		},
		mountInfowindowComponent() {
			this.cleanInfowindow();
			if (this.instanceInfo) {
				this.instanceInfo.$destroy();
			}
			this.instanceInfo = new ComponentClass({
				propsData: {visit_point: this.visitPoint},
			});
			this.instanceInfo.$mount();
			return this.instanceInfo.$el;
		},
		cleanInfowindow() {
			if (this.instanceInfo !== null) {
				this.instanceInfo.$destroy();
				this.instanceInfo = null;
			}
		},
		getAssigedZoneResource(routesResources) {
			this.openLoading();
			const promises = routesResources.map((route) =>
				this.$store.dispatch("moduleZonification/assignedZoneResourceById", route.id)
			);
			Promise.all(promises).then((values) => {
				this.closeLoading();
				values.forEach((value) => {
					if (value.length > 0) {
						let resorceId = value[0].resource_id;
						const zonesResource = value.map(({zone_id}) => zone_id);
						const polygonColor = routesResources.find((r) => r.resource.value === resorceId).color;
						this.drawCartoPolygons(zonesResource.join(","), {
							polygonFill: polygonColor || "#FF00FF",
							lineColor: "#000000",
							cleanPolygon: false,
						});
						this.cartoLayerIds = this.cartoLayerIds.concat(zonesResource);
					}
				});
				if (this.cartoLayerIds.length > 0) this.zoomBoundsGroup(this.cartoLayerIds.join(","));
			});
			this.closeLoading();
		},
		addMarkerResource(resource_data, title = this.$t("MapModule.CurrentPosition")) {
			// Opciones
			let options = {
				drag: false,
				icon: mapMethods.generateMarkerIconResource({active: true}),
				title,
				label: {
					text: "A",
					color: "#fff",
					fontSize: "11.0px",
				},
				info: resource_data,
				infoWindow: {
					content: infowindowContentResource(resource_data),
				},
			};
			const resourceMarker = addMarkerHereMap(resource_data.cy, resource_data.cx, options, true);
			addInfoBubble(resourceMarker, options.infoWindow.content);
			this.resourceMarkers.push(resourceMarker);
		},
		getResourceMarkers() {
			return this.resourceMarkers;
		},
		addMarkerResourceActive(lat, lng, resource, resourceTracking) {
			this.currentPosition = {lat, lng};
			// Opciones
			let options = {
				drag: false,
				icon: mapMethods.generateMarkerIconResource(this.tracking),
				title: this.$t("MapModule.CurrentPosition"),
				label: {
					text: "A",
					color: "#fff",
					fontSize: "11.0px",
				},
				info: resourceTracking,
				infoWindow: {
					content: this.mountInfowindowComponentResource(resource),
				},
				onClick: () => {
					this.tracking = new Tracking(resourceTracking);
				},
			};
			let newMarker = addMarkerHereMap(lat, lng, options);
			addInfoBubble(newMarker, options.infoWindow.content);
			this.listResourceMarkers.push(newMarker);
			this.positionArray.push(newMarker);
		},
		mountInfowindowComponentResource(resource) {
			this.cleanInfowindow();
			if (this.instanceInfo) {
				this.instanceInfo.$destroy();
				this.instanceInfo = null;
			}
			this.instanceInfo = new ComponentClassResourceActive({
				propsData: {
					resourceData: resource,
					tracking: this.tracking,
				},
			});
			this.instanceInfo.$mount();
			return this.instanceInfo.$el;
		},
		/**
		 * ? Description locate on map the resource who reported the panic alarm
		 */
		locatePanicAlarm(notification) {
			this.clearMap();
			if (notification.event === this.PANIC_ALARM) {
				const resourceData = this.$store.getters["chat/contact"](notification.body.resource_id);
				if (resourceData) {
					const {cx, cy} = notification.body;
					const tracking = new Tracking({
						...notification.body,
						positionrecord_id: resourceData.positionrecord_id,
					});
					tracking.active = true;
					// Actualizamos la imagen del recurso, la obtenemos de la info del chat
					const contactInfo = this.$store.getters["chat/contactImg"](resourceData.id);
					const resourceDataUp = {...resourceData, img_url: contactInfo ? contactInfo.img : null};
					setTimeout(() => {
						let options = {
							drag: false,
							icon: mapMethods.generateMarkerIconResource({active: true}),
							title: this.$t("MapModule.CurrentPosition"),
							info: tracking,
							infoWindow: {
								content: infoWindowContentResourceTracking.call(this, resourceDataUp, tracking),
							},
						};
						const resourceMarker = addMarkerHereMap(parseFloat(cy), parseFloat(cx), options, true);
						addInfoBubble(resourceMarker, options.infoWindow.content);
						centerHereMap(parseFloat(cy), parseFloat(cx), {zoom: 11});
						this.drawRadius(parseFloat(cy), parseFloat(cx));
					}, 500);
				}
			}
		},
		drawRadius(lat, lng) {
			let options = {
				center: {lat, lng},
				radius: 20,
			};
			if (this.circle) this.circle.setData(null);
			this.circle = addCircleToMap(options);
		},
		startDefaultGroupTracking(item) {
			this.favoriteGroup = new Group(item);
			// Cerrar conexion de las referencias de los recursos anteriormente seleccionados
			if (this.resourceRefs.length > 0) {
				this.resourceRefs.forEach((element) => element.off());
				this.resourceRefs = [];
			}
			this.getResourceTrackingV2();
		},
		getResourceTrackingV2() {
			const userInfo = JSON.parse(localStorage.getItem("userInfo"));
			const starCountRef = this.database.ref("tracking/" + userInfo.datarutas_company_id);
			starCountRef.once("value").then((snapshot) => {
				snapshot.forEach((childSnapshot) => {
					const key = childSnapshot.key;
					const resourceData = this.resources.find(
						({positionrecord_id, id}) =>
							positionrecord_id === key && this.favoriteGroup.resource_id.includes(id)
					);

					const resourceTracking = childSnapshot.val();
					if (resourceData) {
						const {cx, cy} = resourceTracking;
						const tracking = new Tracking({
							...resourceTracking,
							positionrecord_id: resourceData.positionrecord_id,
						});
						// Actualizamos la imagen del recurso, la obtenemos de la info del chat
						const contactInfo = this.$store.getters["chat/contactImg"](resourceData.id);
						const resourceDataUp = {...resourceData, img_url: contactInfo ? contactInfo.img : null};
						this.addMarkerResourceOndemand(parseFloat(cy), parseFloat(cx), resourceDataUp, tracking);
					}
				});
				if (this.resourceMarkers.length > 0) fitBoundsMarkerGroup(this.resourceMarkers);
			});

			starCountRef.on("child_changed", (snapshot) => {
				const resourceTracking = snapshot.val();
				const resourceIncluded = this.favoriteGroup.resource_id.includes(+resourceTracking.resource_id);
				if (resourceIncluded) {
					const foundResource = this.resourceMarkers.find(
						({info}) => +info.resource_id === +resourceTracking.resource_id
					);
					if (
						foundResource &&
						foundResource.hasOwnProperty("lat") &&
						foundResource.position.lat() !== +resourceTracking.cy
					) {
						this.updateMarkerInfowindows(foundResource, resourceTracking);
						this.updateOnDemandMarkerPosition(foundResource, +resourceTracking.cy, +resourceTracking.cx);
					}
				}
			});
			this.resourceRefs.push(starCountRef);
		},
		handleChangeGroup(val) {
			this.clearMap();
			this.startDefaultGroupTracking(val);
		},
		updateMarkerInfowindows(foundResource, resourceTracking) {
			const resourceData = this.resources.find(({id}) => +id === +resourceTracking.resource_id);
			const $infowindow = document.getElementById(`infoWindow-resource-${resourceData.positionrecord_id}`);

			if (foundResource.info.active !== resourceTracking.active) {
				const icon = mapMethods.generateMarkerIconResource({active: resourceTracking.active});
				foundResource.info.active = resourceTracking.active;
				changeIconInMarkerHereMap(foundResource, icon);
			}

			if (!$infowindow) return;

			if (+foundResource.info.battery !== +resourceTracking.battery) {
				const $battery = document.getElementById(`span-battery-${resourceData.positionrecord_id}`);
				const $batteryText = document.getElementById(`span-battery-text-${resourceData.positionrecord_id}`);
				$battery.innerHTML = this.batteryIcon(+resourceTracking.battery);
				$batteryText.textContent = resourceTracking.battery + "%";
			}

			if (foundResource.info.gps !== resourceTracking.gps) {
				const $gps = document.getElementById(`span-gps-${resourceData.positionrecord_id}`);
				const $gpsText = document.getElementById(`span-gps-text-${resourceData.positionrecord_id}`);
				$gps.innerHTML = this.gpsIcon(resourceTracking.gps);
				$gpsText.textContent =
					resourceTracking.gps === "on"
						? this.$t("StatusMobile.ListStatusMobile.Active")
						: this.$t("StatusMobile.ListStatusMobile.Disabled");
			}

			if (foundResource.info.active !== resourceTracking.active) {
				const $active = document.getElementById(`span-transmission-${resourceData.positionrecord_id}`);
				const $activeText = document.getElementById(`span-transmission-text-${resourceData.positionrecord_id}`);
				$active.innerHTML = this.transmissionIcon(resourceTracking.active);
				$activeText.textContent = resourceTracking.active
					? this.$t("MapModule.OnLine")
					: this.$t("MapModule.OffLine");
			}
		},
		addMarkerResourceOndemand(lat, lng, resource, resourceTracking) {
			this.currentPosition = {lat, lng};
			// Opciones
			let options = {
				drag: false,
				icon: mapMethods.generateMarkerIconResource(resourceTracking),
				title: this.$t("MapModule.CurrentPosition"),
				info: resourceTracking,
				infoWindow: {
					content: infoWindowContentResourceTracking.call(this, resource, resourceTracking),
				},
			};
			let newMarkers = addMarkerHereMap(lat, lng, options, true);
			addInfoBubble(newMarkers, options.infoWindow.content);
			centerHereMap(lat, lng, {zoom: 18});
			this.resourceMarkers.push(newMarkers);
		},
		/**
		 * TODO: Actualizar la posicion del marker con un efecto de movimiento
		 * ? Funcion creada para integrar con modulo OnDemandHistory.vue
		 * @param {Here Maps Marker} marker capturado para actualizar
		 * @param {Float} newLat Nueva posicion en latidud del marker
		 * @param {Float} newLng Nueva posicion en longitud del marker
		 */
		updateOnDemandMarkerPosition(marker, newLat, newLng) {
			let i = 0;
			const deltas = 100;
			const delay = 10;
			let currentPosition = marker.getGeometry();
			let currentLat = currentPosition.lat;
			let currentLng = currentPosition.lng;
			const deltaLat = (newLat - currentLat) / deltas;
			const deltaLng = (newLng - currentLng) / deltas;
			const move = () => {
				if (i >= deltas) return;
				currentLat += deltaLat;
				currentLng += deltaLng;
				marker.setGeometry({lat: currentLat, lng: currentLng});
				i++;
				setTimeout(move, delay);
			};
			move();
		},
		batteryIcon(level) {
			if (level >= 60) {
				return `<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-battery h-7 w-7 stroke-current text-success"><rect x="1" y="6" width="18" height="12" rx="2" ry="2"></rect><line x1="23" y1="13" x2="23" y2="11"></line></svg>`;
			} else if (level < 60 && level >= 30) {
				return `<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-battery h-7 w-7 stroke-current text-warning"><rect x="1" y="6" width="18" height="12" rx="2" ry="2"></rect><line x1="23" y1="13" x2="23" y2="11"></line></svg>`;
			} else {
				return `<svg data-v-25c71de1="" xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-battery-charging h-8 w-8 stroke-current text-danger"><path data-v-25c71de1="" d="M5 18H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h3.19M15 6h2a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-3.19"></path><line data-v-25c71de1="" x1="23" y1="13" x2="23" y2="11"></line><polyline data-v-25c71de1="" points="11 6 7 12 13 12 9 18"></polyline></svg>`;
			}
		},
		transmissionIcon(status) {
			return `<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-wifi h-7 w-7 stroke-current text-${
				status ? "success" : "danger"
			}"><path d="M5 12.55a11 11 0 0 1 14.08 0"></path><path d="M1.42 9a16 16 0 0 1 21.16 0"></path><path d="M8.53 16.11a6 6 0 0 1 6.95 0"></path><line x1="12" y1="20" x2="12.01" y2="20"></line></svg>`;
		},
		gpsIcon(status) {
			return `<i class="vs-icon notranslate icon-scale mt-1 material-icons small vs-icon-${
				status === "on" ? "success" : "danger"
			} bg-small vs-icon-bg">gps_fixed</i>`;
		},
		/**
		 * *Controlar las acciones a ejecutar cuando el componente mapa es montados desde el componente de onDemand
		 * 3 => Puntos de visita asignados al recurso
		 * 4 => Zonas asignadas al recurso
		 */
		handleMountedFromOnDemand() {
			this.getResourceTracking(this.markerData[0]).then((response) => {
				this.onDemandResourceTracking = response;
				if (this.onDemandResourceTracking) {
					const {cx, cy, active} = this.onDemandResourceTracking;
					if (active) {
						this.addMarkerResourceOndemand(
							parseFloat(cy),
							parseFloat(cx),
							this.markerData[0],
							this.onDemandResourceTracking
						);
						this.addMarkerVisitPoint(
							{...this.onDemandEvent, name: this.onDemandEvent.visit_point_name},
							false
						);
						this.listenOnDemandResourceTracking(this.markerData[0]);
						setTimeout(() => {
							fitBoundsMarkerGroup(this.resourceMarkers);
						}, 500);
					}
				}
			});
		},
		/**
		 * *Controlar las acciones a ejecutar cuando el componente mapa es montados desde el componente de resorce view
		 * *Valida la propiedad resourceViewActiveTab que represnta la tab que sae encuentra activa en el componente resourceView
		 * 3 => Puntos de visita asignados al recurso
		 * 4 => Zonas asignadas al recurso
		 */
		handleMountedFromResourceView() {
			if (this.resourceViewActiveTab === 3) {
				this.drawCartoPolygons(this.resourceViewAssignedZones.join(","));
			}
		},
		callbackClickOnMap(markerEvent) {
			this.getCallbackClick(markerEvent);
		},
		changeMarkerPosition(newPosition) {
			//Transition
			this.i = 0;
			this.deltaLat = (newPosition.lat - this.currentPosition.lat) / this.numDeltas;
			this.deltaLng = (newPosition.lng - this.currentPosition.lng) / this.numDeltas;
			this.moveMarker();
		},
		changeCursor(type = "pointer") {
			const mapElement = getHereMapObj().getElement(); // Obtén el elemento DOM del mapa
			if (mapElement) {
				mapElement.style.cursor = type;
			}
		},
	},
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/rutify/settings/_colors.scss";
/** custom content for map */
.map-custom-container {
	margin-top: calc(100% - 112%);
	margin-left: -35px;
	margin-right: -35px;
	height: 88vh;
}

.street-vien-container {
	width: 100%;
	height: 40vh;
}

@media (min-width: 1400px) {
	.map-custom-container {
		margin-top: calc(100% - 102%);
		height: 93vh;
	}

	.street-vien-container {
		width: 100%;
		height: 60vh;
	}
}

@media (max-width: 992px) {
	.map-custom-container {
		margin-top: calc(100% - 109%);
		height: 89vh;
	}

	.street-vien-container {
		width: 100%;
		height: 40vh;
	}
}

@media (max-width: 575px) {
	.map-custom-container {
		margin-left: -20px;
		margin-right: 0;
	}
}

.customizer-btn-map-opc {
	position: fixed;
	background: $orange !important;
	width: 40px !important;
	height: 50px !important;
	top: 50%;
	right: 1%;
	border-radius: 5px;
	z-index: 50000;
	clear: both;
}

.customizer-btn-map-clear {
	position: fixed;
	background: $orange !important;
	width: 40px !important;
	height: 45px !important;
	top: 45%;
	right: 1%;
	border-radius: 5px;
	z-index: 50000;
	clear: both;

	&:after {
		content: "";
		position: absolute;
		width: 1.5em;
		height: 0.6px;
		top: 2.3em;
		left: 0.4em;
		background: white;
	}
}

.map-top-right-possition {
	position: fixed;
	top: 69px;
	right: 100px;
	border-top-right-radius: 0;
	border-bottom-right-radius: 0;
	z-index: 50000;
}

.map-top-left-possition {
	position: fixed;
	top: 100px;
	left: 270px;
	border-top-right-radius: 0;
	border-bottom-right-radius: 0;
	z-index: 50000;
}

.map-top-left-possition-reducce-button {
	position: fixed;
	top: 100px;
	left: 90px;
	border-top-right-radius: 0;
	border-bottom-right-radius: 0;
	z-index: 50000;
}
</style>
